import { combineReducers } from "redux";
import historyArtifactsReducer from "./historyArtifacts/reducer";
import authFirebaseTokenReducer from "./verifyJwtTokenAccess/reducer";

const rootReducer = combineReducers({
  historyArtifactsReducer,
  authFirebaseTokenReducer,
});

export default rootReducer;
